import { track } from "jiffy-analytics";
import ModalFileUpload from "components/jiffy/added-to-cart-modal-v2/modal-file-upload";
import { submitDtfEvent, submitCompletedEvent } from "common/utils/mixpanel/submit-dtf-events";
import { trackRudderstackImageUploadStarted } from "common/utils/rudderstack/tracker";
import { generateUUID } from "common/utils/uuid";
import "./bogo-info-modal.scss";

const UPLOAD_LOCATION = "bogo_info_modal";
const MODAL_INTERACTION_EVENT = "bogo_info_modal_interaction";

const trackModalInteraction = action => {
  track(MODAL_INTERACTION_EVENT, { action });
};
const DTF_CATALOG_NUMBER = "DTF001";

const getElements = (() => {
  let $cachedModal = null;

  return {
    get $$modal() {
      return $(this.$modal);
    },

    get $modal() {
      $cachedModal ??= document.getElementById("bogo-info-modal");
      return $cachedModal;
    },

    get $triggerButton() {
      return document.querySelector(".js-hero-bogo-sticker-button");
    },

    get $fileInput() {
      return this.$modal?.querySelector(".js-bogo-modal-file-input");
    },

    get $retryButton() {
      return this.$modal?.querySelector(".js-bogo-modal-retry-button");
    },

    get $shopBlanksLink() {
      return this.$modal?.querySelector(".js-bogo-modal-shop-blanks");
    },

    get $uploadLabel() {
      return this.$modal?.querySelector(".js-bogo-modal-upload-label");
    },

    get $closeButton() {
      return this.$modal?.querySelector(".js-close-bogo-info-modal");
    },

    get $signupLink() {
      return this.$modal?.querySelector(".js-bogo-modal-signup-link");
    }
  };
})();

let fileUploader = null;
let trackingInitialized = false;

class BogoModalFileUpload extends ModalFileUpload {
  get $labels() {
    return this.$modal.querySelectorAll(".js-bogo-modal-upload-label");
  }

  get $progressContainers() {
    return this.$modal.querySelectorAll(".js-bogo-modal-upload-progress");
  }

  get $progressTexts() {
    return this.$modal.querySelectorAll(".js-bogo-modal-progress-text");
  }

  get $errorContainers() {
    return this.$modal.querySelectorAll(".js-bogo-modal-upload-error");
  }

  get $errorTexts() {
    return this.$modal.querySelectorAll(".js-bogo-modal-error-text");
  }

  trackUploadStarted() {
    if (!this.uploadedFile) return;

    this.uploadUuid = generateUUID();
    this.uploadStartTime = performance.now();

    submitDtfEvent("image_upload_started", {
      page: UPLOAD_LOCATION,
      catalog_number: DTF_CATALOG_NUMBER,
      type: "browse",
      file_name: this.uploadedFile.name,
      file_type: this.uploadedFile.type,
      file_size: this.uploadedFile.size,
      dpi: 300,
      upload_uuid: this.uploadUuid
    });

    trackRudderstackImageUploadStarted({
      catalog_number: DTF_CATALOG_NUMBER,
      dpi: 300,
      file_name: this.uploadedFile.name,
      file_type: this.uploadedFile.type,
      file_size: this.uploadedFile.size,
      location: UPLOAD_LOCATION,
      business_line: "Transfers",
      artworks_count: 1,
      upload_uuid: this.uploadUuid
    });
  }

  trackUploadCompleted(response) {
    if (!this.uploadedFile) return;

    submitCompletedEvent({
      file: this.uploadedFile,
      catalogNumber: DTF_CATALOG_NUMBER,
      uploadedOn: UPLOAD_LOCATION,
      multiArtwork: false,
      businessLine: "Transfers",
      dpi: 300,
      artworksCount: 1,
      uploadStartTime: this.uploadStartTime,
      artwork: response,
      uploadUuid: this.uploadUuid
    });
  }
}

const initFileUpload = () => {
  const { $modal } = getElements;
  if (!$modal || fileUploader) return;

  fileUploader = new BogoModalFileUpload($modal);

  const { $fileInput } = getElements;
  $fileInput?.addEventListener("change", () => {
    const file = $fileInput.files?.[0];
    if (file && fileUploader.handleFileSelection(file)) {
      fileUploader.uploadArtwork();
    }
    $fileInput.value = "";
  });

  getElements.$retryButton?.addEventListener("click", () => {
    fileUploader.uploadArtwork();
  });

  getElements.$$modal.on("hidden.bs.modal", () => {
    fileUploader?.resetUI();
  });
};

const initTracking = () => {
  if (trackingInitialized) return;
  trackingInitialized = true;

  getElements.$shopBlanksLink?.addEventListener("click", () => {
    trackModalInteraction("shop_blanks_now");
  });

  getElements.$uploadLabel?.addEventListener("click", () => {
    trackModalInteraction("upload_design");
  });

  getElements.$closeButton?.addEventListener("click", () => {
    trackModalInteraction("close");
  });

  getElements.$signupLink?.addEventListener("click", () => {
    track("click_discount_signup_link", {
      current_page: "Home"
    });
  });
};

const initBogoInfoModal = () => {
  getElements.$triggerButton?.addEventListener("click", () => {
    getElements.$$modal.modal("show");
    initFileUpload();
    initTracking();
  });
};

export default initBogoInfoModal;
